class CoastProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.coast-product-grid__tab'));
    this.panels = Array.from(this.querySelectorAll('.coast-product-grid__panel'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab));
    });

    this.querySelectorAll('.coast-product-grid__arrow').forEach((button) => {
      button.addEventListener('click', () => this.scrollPanel(button));
    });
  }

  selectTab(tab) {
    const index = tab.dataset.tabIndex;

    this.tabs.forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.panelIndex === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  scrollPanel(button) {
    const panel = button.closest('.coast-product-grid__panel');
    const scroller = panel && panel.querySelector('.coast-product-grid__scroller');
    if (!scroller) return;

    const amount = scroller.clientWidth * 0.8;
    scroller.scrollBy({
      left: button.dataset.direction === 'prev' ? -amount : amount,
      behavior: 'smooth',
    });
  }
}

customElements.define('coast-product-tabs', CoastProductTabs);
